import { useTaxResidencesDetailsProps } from '../hooks/useTaxResidencesDetailsProps';

import { KycInformationSection } from '@/features/kyc/components/userInformation/InformationSection';

import { IUser } from '@/features/user/store/user.model';

import { featuresSlugs } from '@/features/roles/store/models/features.model';

interface ITaxResidenceDetails {
  user: IUser;
  isSectionEditable: boolean;
  toogleSectionEditMode: () => void;
}

export function TaxResidencesDetails({ user, isSectionEditable, toogleSectionEditMode }: ITaxResidenceDetails) {
  const { taxResidenceData } = useTaxResidencesDetailsProps(user);

  return (
    <KycInformationSection
      section={taxResidenceData}
      isOnEdition={false}
      sectionKey="tax-residences"
      isLoading={false}
      isSectionNotEditable={isSectionEditable}
      featureSlug={featuresSlugs.EDIT_TAX_RESIDENCES}
      onEdit={() => toogleSectionEditMode()}
    />
  );
}
